export enum DiarySync {
  None,
  Outlook,
  GoogleCalender,
  Office365Calender,
}

export enum DiarySyncLevel {
  JustMyAppointment,
  EverythingAtMyBranch,
  EverythingAtAllBranch,
}
